/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_View_InvoiceInputs */

const vi_einvoice_view_invoice = /** @type {(inputs: Einvoice_View_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem hóa đơn`)
};

/**

* @param {Einvoice_View_InvoiceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_view_invoice = /** @type {((inputs?: Einvoice_View_InvoiceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_View_InvoiceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_view_invoice(inputs)
});